import {React, useEffect} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import dashboard from "../../images/dashboard.png";
import workouts from "../../images/workouts.png";
import exercise from "../../images/exercise.png";
import password from "../../images/password.png";
import logout from "../../images/logout.png";
import { useState } from "react";
import { BASE_URL_MEDIA } from "../../api/Constants";
import { BASE_URL_COMPETITION } from "../../api/Constants";
import { getImageUrl } from 'components/helpers/Helpers';
import "./sidebar.css";
import { FaArrowLeft } from "react-icons/fa";

const Sidebar = () => {
  const navigate = useNavigate();
  const trainername = localStorage.getItem("trainername");
  const trainerimage = localStorage.getItem("trainerimage");
  const traineremail = localStorage.getItem("traineremail");

  const activeTab = localStorage.getItem("activeTab");
  const [tab, setTab] = useState(activeTab);
  const location = useLocation();
  const [fromUrl, setFromUrl] = useState(null);

  const Signout = () => {
    localStorage.clear();
    navigate("/trainer/");
  };

    useEffect(() => {

    const params = new URLSearchParams(location.search);
    const from = params.get("from");
    if (from) {
      setFromUrl(decodeURIComponent(from));
      // optionally persist in sessionStorage so refresh still works
      sessionStorage.setItem("trainerFromUrl", decodeURIComponent(from));
    } else {
      // fallback to persisted value if exists
      const saved = sessionStorage.getItem("trainerFromUrl");
      if (saved) setFromUrl(saved);
    }

  }, [location.search]);



  const handleLogoClick = () => {

    if (fromUrl) {
      window.location.href = fromUrl;
    } else {
      navigate("/trainer/dashboard"); // trainer home fallback
    }
  };

  return (
    <div className="sidebar">
      <div className="user__info">
      <img
        src={
          !trainerimage || trainerimage === 'null' || trainerimage === 'undefined'
            ? `${BASE_URL_COMPETITION}/static/media/user.89aaeb263a46bd353262.png`
            : getImageUrl(trainerimage, BASE_URL_MEDIA)
        }
        onClick={handleLogoClick}
        style={{ cursor: "pointer" }}   
            
      />
        <div style={{ maxWidth: '100%'}}>
        <p className="dashboard" style={{ margin: 0, padding: 0 , wordBreak: 'break-all', overflow: 'anywhere'}}>Welcome, {trainername}</p>
        <p className="user_name" style={{ margin: 0, padding: 0, wordBreak: 'break-all', overflow: 'anywhere'  }}>{traineremail}</p>
        </div>
      </div>
      <div className="side-hr"> </div>
      <div className="links">
        <ul>
          <li
            onClick={() => {
              localStorage.setItem("activeTab", "dashboard");
              navigate("/dashboard");
            }}
            className={`${(tab == "dashboard" || tab == "pass" || tab == "create-program-dashboard") ? "active" : ""}`}
          >
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <img src={dashboard} alt="" />
              <span style={{ marginLeft: 8 }}>Dashboard</span>
            </span>
          </li>
          {(tab === "dashboard" || tab === "create-program-dashboard") && (
            <ul className="submenu" style={{ marginLeft: 20}}>
              <li
                onClick={() => {
                  //localStorage.setItem("activeSubTab", "create-program-dashboard");
                  //setTab("create-program-dashboard");
                  navigate("/create-program");
                }}
                className={tab == "create-program-dashboard" ? "active" : ""}
                style={{ cursor: 'pointer' }}
              >
               <span style={{fontSize: '0.95em' }}> Create New Program </span>
              </li>
            </ul>
          )}
          <li
            onClick={() => {
              localStorage.setItem("activeTab", "program");
              navigate("/programm-list");
            }}
            className={`${(tab == "program" || tab == "create-program-program") ? "active" : ""}`}
          >
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <img src={workouts} alt="" />
              <span style={{ marginLeft: 8 }}>Programs</span>
            </span>
          </li>
          {(tab === "program" || tab === "create-program-program") && (
            <ul className="submenu" style={{ marginLeft: 20}}>
              <li
                onClick={() => {
                  //localStorage.setItem("activeSubTab", "create-program-program");
                  //setTab("create-program-program");
                  navigate("/create-program");
                }}
                className={tab == "create-program-program" ? "active" : ""}
                style={{ cursor: 'pointer' }}
              >
               <span style={{fontSize: '0.95em' }}> Create New Program </span>
              </li>
            </ul>
          )}

          {/* <li
            onClick={() => {
              localStorage.setItem("activeTab", "groups");
              navigate("/group");
            }}
            className={`${tab == "groups" ? "active" : ""}`}
          >
            <img src={gicon} alt="" /> Groups
          </li> */}
          <li
            onClick={() => {
              localStorage.setItem("activeTab", "exercise");
              navigate("/exercises");
            }}
            className={`${tab == "exercise" ? "active" : ""}`}
          >
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <img src={exercise} alt="" />
              <span style={{ marginLeft: 8 }}>Exercises</span>
            </span>
          </li>
          <li
            onClick={() => {
              localStorage.setItem("activeTab", "pass");
              navigate("/change");
            }}
            className={`${""}`}
          >
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <img src={password} alt="" />
              <span style={{ marginLeft: 8 }}>Change password</span>
            </span>
          </li>
          <li style={{ cursor: "pointer" }} onClick={() => Signout()}>
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <img src={logout} />
              <span style={{ marginLeft: 8 }}>Logout</span>
            </span>
          </li>
        </ul>
      </div>
      <div className="side-hr"></div>

      {fromUrl && (

        <button
          onClick={() => (window.location.href = fromUrl)}
          className="flex items-center px-8 py-2 rounded-3xl bg-blue-600 text-black shadow-lg hover:bg-blue-700 transition-all duration-200"
          style={{ borderRadius: '9999px' }}
        >
          <FaArrowLeft size={18} />
          <span className="font-semibold">Back to Admin</span>
        </button>

      )}
    </div>
  );
};

export default Sidebar;
